import { call, put, take, takeEvery } from 'typed-redux-saga';

import { debugHalt } from '../../../../../shared/features/room-agent/dtmf/debug-menu/actions';
import { disconnectConferenceAction, disconnectedFromConferenceDoneAction } from '../../conference/slice';
import { SignalingAPI } from '../api/SignalingAPI';
import { HaltReason } from '../constants';

export function* debugSaga({ signaling }: { signaling: SignalingAPI }) {
    yield* takeEvery(debugHalt, function* () {
        try {
            yield* put(disconnectConferenceAction());
            yield* take(disconnectedFromConferenceDoneAction);
        } finally {
            yield* call([signaling, signaling.halt], {
                reason: HaltReason.NO_INTERNET_CONNECTION,
                description: `Debug halt`,
            });
        }
    });
}
